module.exports = __webpack_public_path__ + "img/bank_accounts.d0b8cd3d.svg";